module.exports = __webpack_public_path__ + "media/产品宣传.e4f67477.mp4";